export const ORDER_LINK =
  "https://docs.google.com/forms/d/1266EQ6fE-x6BLXgE3hWxm87aGPjsz-std5gNGomEzMU/edit?usp=drivesdk";
